import { useQuery } from '@tanstack/react-query';
import { fetchCompanyProfile, type CompanyProfileData } from '../api/companies';

export function useCompanyProfile(companySlug?: string) {
  return useQuery<CompanyProfileData | undefined, Error>({
    queryKey: ['company-profile', companySlug],
    queryFn: () => {
      if (!companySlug) throw new Error('Missing company slug');
      return fetchCompanyProfile(companySlug);
    },
    enabled: Boolean(companySlug),
    staleTime: 1000 * 60,
  });
}

